import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "timeBlock" */ './index'),
  loading: () => null,
});
